export function BrandMark() {
  return (
    <span className="brand-mark" aria-hidden="true">
      <img alt="" src="/qualtio-brand-mark.png" />
    </span>
  );
}
